export default __webpack_public_path__ + "static/media/svg-1.f2a6c5d0.svg";